export default __webpack_public_path__ + "static/media/giraffe-blue.c793d992.svg";